<template>
  <!-- 问答板块 -->
  <div class="id_7 clear">

    <div class="title" v-if="data.title" v-html="data.title"></div>

    <div class="box">
      <div class="icon clear">
        <img class="fl" src="//img.webloom.cn/img/98a7f1d155dcd81668a644efa2ab5ce1.png">
        <div class="bold span fl">Q</div>
      </div>

      <div class="question" v-html="data.question" ref="question"></div>

    </div>

    <div class="box">
      <!-- 统一的插入功能组件 -->
      <ModuleInserter
        ref="moduleInserter"
        :features="insertFeatures"
        :target-ref.sync="$refs.answer"
        @image-upload="handleImageInsert"
        @component-inserted="handleComponentInserted"
      />
      
      <div class="icon clear">
        <img class="fl" src="//img.webloom.cn/img/2d9a86c4615b2c0cd2b57e3f39be6f3c.png">
        <div class="bold span fl">A</div>
      </div>
      <div class="answer" ref="answer" v-html="data.answer"></div>

    </div>

  </div>
</template>

<script>
import ModuleInserter from './ModuleInserter.vue'

export default {
  props: {
    data: Object
  },
  name: 'id_7',
  components: {
    ModuleInserter
  },
  data () {
    return {
      insertFeatures: ['image', 'highlight', 'columns', 'table', 'file']
    }
  },
  methods: {
    /**
     * 打开插入功能面板
     */
    openInsertPanel () {
      this.$refs.moduleInserter.openPanel()
    },
    
    /**
     * 处理图片插入事件（由ModuleInserter组件触发）
     */
    handleImageInsert () {
      this.upImg()
    },
    
    /**
     * 处理组件插入完成事件（由ModuleInserter组件触发）
     */
    handleComponentInserted () {
      // 组件插入完成后的回调，可用于触发高度更新等操作
    },
    
    /**
     * 上传图片并插入到answer区域
     */
    upImg () {
      this.$api.upImg().then((url) => {
        let str = `<img src="${url}"><div class="img_title">(图片介绍，不需要可自行删除)</div>`
        this.$refs.answer.innerHTML = this.$refs.answer.innerHTML + str
      })
    },
    
    /**
     * 获取组件完整数据（包括自身数据和插入的子组件数据）
     * @returns {Object} 完整的组件数据
     */
    getFullData () {
      const result = {
        id: 7,
        title: '',
        question: null,
        questionComponents: [],
        answer: null,
        answerComponents: []
      }
      
      // 获取自身基本数据
      if (this.$refs.title) {
        result.title = this.$refs.title.innerHTML
      }
      
      // 获取question区域的子组件数据
      if (this.$refs.question) {
        result.questionComponents = this.collectComponentsFromElement(this.$refs.question)
      }
      
      // 获取answer区域的子组件数据
      if (this.$refs.answer) {
        // 先同步answer区域的组件状态
        if (this.$refs.moduleInserter) {
          this.$refs.moduleInserter.getInsertedComponentsData().forEach(item => {
            if (item.componentInstance && typeof item.componentInstance.saveState === 'function') {
              item.componentInstance.saveState()
            }
          })
        }
        result.answerComponents = this.collectComponentsFromElement(this.$refs.answer)
      }
      
      return result
    },
    
    /**
     * 从指定元素收集子组件数据
     * @param {HTMLElement} element - 目标元素
     * @returns {Array} 子组件数据数组
     */
    collectComponentsFromElement (element) {
      const components = []
      if (!element) return components
      
      const children = element.childNodes
      const idMap = { 'id_10': 10, 'id_11': 11, 'id_12': 12, 'id_13': 13 }
      
      for (let i = 0; i < children.length; i++) {
        const child = children[i]
        
        // 跳过空段落
        if (child.classList && child.classList.contains('empty-text-paragraph') && !child.textContent) {
          continue
        }
        
        // 检查是否为组件元素
        const classList = child.classList
        let componentId = null
        
        if (classList) {
          for (let j = 0; j < classList.length; j++) {
            const className = classList[j]
            if (className.startsWith('id_')) {
              componentId = idMap[className]
              break
            }
          }
        }
        
        if (componentId) {
          // 组件元素
          components.push({
            type: 'component',
            id: componentId
          })
        } else if (child.tagName) {
          // HTML元素
          const html = child.outerHTML
          if (html && html.trim() !== '' && html !== '<br>') {
            components.push({
              type: 'html',
              content: html
            })
          }
        } else if (child.textContent && child.textContent.trim() !== '') {
          // 纯文本
          components.push({
            type: 'text',
            content: child.textContent
          })
        }
      }
      
      return components
    },
    
    /**
     * 从数据中恢复子组件到指定元素
     * @param {HTMLElement} element - 目标元素
     * @param {Array} components - 子组件数据数组
     */
    restoreComponentsToElement (element, components) {
      if (!element || !components || !Array.isArray(components)) return
      
      // 清空元素内容
      element.innerHTML = ''
      
      const typeMap = { 13: 'highlight', 11: 'columns', 12: 'table', 10: 'file' }
      const placeholders = []
      
      // 第一阶段：构建DOM结构
      components.forEach((item, index) => {
        if (item.type === 'text') {
          const p = document.createElement('p')
          p.textContent = item.content || ''
          element.appendChild(p)
        } else if (item.type === 'html') {
          element.insertAdjacentHTML('beforeend', item.content || '')
        } else if (item.type === 'component') {
          const placeholder = document.createElement('div')
          placeholder.setAttribute('data-component-index', index)
          element.appendChild(placeholder)
          placeholders.push({ placeholder, compData: item })
        }
      })
      
      // 第二阶段：替换占位符为Vue组件
      if (placeholders.length > 0 && this.$refs.moduleInserter) {
        this.$nextTick(() => {
          placeholders.forEach(({ placeholder, compData }) => {
            const type = typeMap[compData.id]
            if (type) {
              this.$refs.moduleInserter.insertVueComponentAt(type, compData, placeholder)
            }
          })
        })
      }
    },
    
    /**
     * 从数据中恢复所有子组件
     */
    initComponents () {
      // 恢复question区域
      if (this.data && this.data.questionComponents && this.data.questionComponents.length > 0) {
        this.$nextTick(() => {
          this.restoreComponentsToElement(this.$refs.question, this.data.questionComponents)
        })
      }
      
      // 恢复answer区域
      if (this.data && this.data.answerComponents && this.data.answerComponents.length > 0) {
        this.$nextTick(() => {
          this.restoreComponentsToElement(this.$refs.answer, this.data.answerComponents)
        })
      }
    }
  },
  watch: {
    'data.answer': {
      immediate: false,
      handler () {
        this.$nextTick(() => {
          if (this.$refs.moduleInserter && this.$refs.answer) {
            this.$refs.moduleInserter.setTargetRef(this.$refs.answer)
          }
        })
      }
    },
    'data.questionComponents': {
      immediate: false,
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          this.$nextTick(() => {
            this.restoreComponentsToElement(this.$refs.question, newVal)
          })
        }
      }
    },
    'data.answerComponents': {
      immediate: false,
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          this.$nextTick(() => {
            this.restoreComponentsToElement(this.$refs.answer, newVal)
          })
        }
      }
    }
  },
  mounted () {
    console.log(this.data, 'id_7')
    this.$nextTick(() => {
      if (this.$refs.moduleInserter && this.$refs.answer) {
        this.$refs.moduleInserter.setTargetRef(this.$refs.answer)
      }
      // 从数据中恢复子组件
      this.initComponents()
    })
  },
  beforeDestroy () {
    // 销毁所有动态创建的组件
    if (this.$refs.moduleInserter) {
      this.$refs.moduleInserter.destroyComponents()
    }
  }
}
</script>
<style lang="scss">
.id_7{
  word-wrap:break-word;
  .answer{
    img{
      width: 100%;
      margin: 24px 0;
    }
    .img_title{
      font-size: 14px;
      line-height: 1.4;
      text-align: center;
      color: #909399;
      margin-top: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
.id_7{
  margin: 32px 0;
  background-color: #fff;
  .title{
    font-size: 14px;
    line-height: 1.6;
  }
  .box{
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 20px;
    margin-top: 40px;
    position: relative;
    .btn{
      position: absolute;
      right: 0;
      top: 32px;
      cursor: pointer;
      /deep/ i{
        font-style: normal !important;
      }
      .icon{
        width: 30px;
        height: 30px;
        transition: transform 0.2s ease;
        &:hover{
          transform: scale(1.1);
        }
      }
    }
    .icon{
      position: absolute;
      background-color: #fff;
      padding-left: 8px;
      padding-right: 8px;
      top: -15px;
      left: 24px;
      .span{
        line-height: 1.5;
        font-size: 20px;
        margin-left: 8px;
      }
    }
    .question,.answer{
      white-space: pre-wrap;
      word-break: break-word;
      font-size: 16px;
      line-height: 1.6;
    }
    // 确保question区域内的插入组件样式正确
    .question{
      padding: 4px;
      /deep/ .id_10, /deep/ .id_11, /deep/ .id_12, /deep/ .id_13{
        padding: 0;
        padding-top: 12px;
        padding-bottom: 4px;
      }
      // 确保插入到contenteditable内部的Vue组件不可编辑
      > div[contenteditable="false"]{
        margin-top: 16px;
        margin-bottom: 16px;
        outline: none;
      }
      // 组件后自动插入的空段落样式
      > p.empty-text-paragraph{
        margin: 0;
        padding: 0;
        min-height: 1.6em;
        line-height: 1.6;
        font-size: 16px;
        color: #333;
        outline: none;
      }
    }
    // 确保answer区域内的插入组件样式正确
    .answer{
      padding: 4px;
      /deep/ .id_10, /deep/ .id_11, /deep/ .id_12, /deep/ .id_13{
        padding: 0;
        padding-top: 12px;
      }
      // 确保插入到contenteditable内部的Vue组件不可编辑
      > div[contenteditable="false"]{
        margin-top: 16px;
        margin-bottom: 16px;
        outline: none;
      }
      // 组件后自动插入的空段落样式
      > p.empty-text-paragraph{
        margin: 0;
        padding: 0;
        min-height: 1.6em;
        line-height: 1.6;
        font-size: 16px;
        color: #333;
        outline: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_7.vue